<div class="summary-card" *ngIf="rows?.length" [class.compact]="compact">
  <h3>{{ title }}</h3>
  <div class="summary-table-wrapper">
    <table class="summary-table" [class.has-in-house]="showInHouse">
      <colgroup>
        <col class="desc-col" />
        <col class="num-col" />
        <col class="num-col" *ngIf="showInHouse" />
        <col class="num-col" />
        <col class="num-col" />
      </colgroup>
      <thead>
        <tr>
          <th>Description</th>
          <th>{{ headingMode === 'regular' ? 'Regular' : 'CLE' }}</th>
          <th *ngIf="showInHouse">In-House</th>
          <th>Ethics</th>
          <th>{{ headingMode === 'regular' ? 'Professionalism' : 'Prof' }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of displayRows">
          <td class="label" [class.font-weight-bold]="isHighlightRow(row)">{{ row.courseDescription || row.summaryLine }}</td>
          <td class="numeric" [class.highlight-value]="isHighlightRow(row) && row.regular > 0">{{ row.regular | number:'1.0-2' }}</td>
          <td class="numeric" [class.highlight-value]="isHighlightRow(row) && row.ethics > 0">{{ row.ethics | number:'1.0-2' }}</td>
          <td class="numeric" [class.highlight-value]="isHighlightRow(row) && row.prof > 0">{{ row.prof | number:'1.0-2' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
